export const Single = () => {
  const breadcrumbs = document.querySelectorAll(".js-single-breadcrumb > span");
  const breadcrumbsLength = breadcrumbs.length;

  if (breadcrumbsLength > 5) {
    breadcrumbs.forEach((breadcrumb, index) => {
      if (index > 3 && index < breadcrumbsLength - 1) {
        breadcrumb.remove();
      }
    });
  }
};
